import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const DurationRuleDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [

  ],
  subscriptions: {

  },
  defaultColumns: [
  
  ],
  columnConfig: {

  }
}